import React from "react";
import { CTAButton } from "./CTAButton";
import { Reveal } from "./Reveal";
export function FoundingClient() {
  return <section aria-labelledby="founding" className="section-pad border-b border-line" data-id="element-204" data-mp="wykpdeq9a878">
      <div className="page-container" data-id="element-205" data-mp="iz1guktj8uue">
        <Reveal className="max-w-3xl" data-id="element-206" data-mp="j27743dwe2rp">
          <div className="rounded-[3px] border border-gold/60 p-1.5" data-id="element-207" data-mp="nyo47n32rrgx">
            <div className="rounded-[2px] border border-gold/20 bg-surface px-6 py-12 sm:px-14 sm:py-16" data-id="element-208" data-mp="o10lrz4x7ztg">
              <p className="eyebrow flex items-center gap-3" data-id="element-209" data-mp="e0zzc4br93l1">
                <span className="tabular-nums" data-id="element-210" data-mp="e2kvtzhmqwlj">08</span>
                <span className="h-px w-6 bg-gold/60" aria-hidden="true" data-id="element-211" data-mp="a4wb8nxtgpd" />
                <span data-id="element-212" data-mp="58pm0e5kchzk">Cupos limitados</span>
              </p>
              <h2 id="founding" className="h2-section mt-4" data-id="element-213" data-mp="597qfy2dq2ik">
                Programa <span className="text-gold" data-id="element-214" data-mp="3mgjoar5e7zua">Cliente Fundador</span>
              </h2>
              <p className="body-copy mt-6" data-id="element-215" data-mp="3rgfrio69nn8s">
                Solo 3 cupos con acompañamiento directo. El trabajo es personalizado, por
                eso no aceptamos muchos negocios a la vez. Cuando se llenen, esta modalidad
                se cierra.
              </p>
              <div className="mt-10 border-t border-line pt-10" data-id="element-216" data-mp="cyfj0ov67t9l">
                <CTAButton source="founding" microcopy="Solo si tu negocio califica" data-id="element-217" data-mp="qvausp2t3ytc" />
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}